var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13pt",
    height: "11pt",
    viewBox: "0 0 13 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.195 3.531c.004.004.004.008 0 .012 0 .016-.008.027-.015.039l-.086.102-6.281 7.453-.055.062a.048.048 0 01-.04.02.063.063 0 01-.042-.02l-.004-.008-.035-.039-6.5-7.437-.117-.133C.012 3.57.004 3.559 0 3.543v-.012l.195-.05L6.602 1.8l6.433 1.687zm0 0",
    fill: "#90d8f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 3.531v.012l-.134.047L9.898 4.69H3.29L.164 3.598 0 3.543v-.012c0-.02.004-.035.012-.05l.039-.07L1.25 1.386h10.7l1.187 2.008.047.085a.079.079 0 01.015.051zm0 0",
    fill: "#b1e4f9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.922 2.773h5.344l.632 1.918H3.29zm0 0",
    fill: "#e4f6ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.898 4.691l-3.128 6.45-.036.074a.043.043 0 01-.03 0l-.036-.063-3.379-6.457zm0 0",
    fill: "#b1e4f9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25.004H3.941c-.011 0-.023 0-.035.008L1.25 1.387l2.672 1.386h5.344l2.675-1.386L9.285.012C9.273.004 9.262.004 9.25.004zm0 0",
    fill: "#90d8f9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25.004H7.797l1.3.672a.8.8 0 01.426.71.79.79 0 01-.425.712l-1.301.675h1.469l2.675-1.386L9.285.012C9.273.004 9.262.004 9.25.004zm0 0",
    fill: "#75cef9"
  })));
};
export default SvgDiamond;